import React from 'react';
import { Controller } from 'react-hook-form';

const FormComponent = ({
  rules = {},
  friendlyName,
  ...props
}) => {
  const keys = Object.keys(rules);

  const validations = keys.reduce((acc, key) => {
    switch (key) {
      case 'required':
        acc['required'] = {
          message: 'Veld is verplicht',
          value: rules['required'],
        };
        break;
      case 'pattern':
        acc['pattern'] = {
          message: 'Geen correct telefoonnummer',
          value: rules['pattern'],
        };
      case 'validate':
        acc['validate'] = rules['validate'];
        break;
      default:
      return null;
    }

    return acc;
  }, {});

  return <Controller {...props} rules={validations} />
};

export default FormComponent;